import { lazy } from 'react';
import getRouterBasename from '@/lib/router';
import { Navigate, createBrowserRouter } from 'react-router-dom';

// Lazy load route components for code splitting
const AuthCallback = lazy(() => import('pages/AuthCallback'));
const Element = lazy(() => import('pages/Element'));
const Env = lazy(() => import('pages/Env'));
const Home = lazy(() => import('pages/Home'));
const Login = lazy(() => import('pages/Login'));
const Thread = lazy(() => import('pages/Thread'));
const VtpViewer = lazy(() => import('@/components/VtpViewer'));

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <Home />
    },
    {
      path: '/env',
      element: <Env />
    },
    {
      path: '/thread/:id?',
      element: <Thread />
    },
    {
      path: '/element/:id',
      element: <Element />
    },
    {
      path: '/viewer/*',
      element: <VtpViewer />
    },
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/login/callback',
      element: <AuthCallback />
    },
    {
      path: '*',
      element: <Navigate replace to="/" />
    }
  ],
  { basename: getRouterBasename() }
);
